import React from 'react';

// Global Form
// @ts-ignore
import RenderDropdown from 'forms/RenderDropdown';
import { Field } from 'react-final-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { SprayMethod } from 'services/sprayEvents/types';
import { EntityId } from 'services/entities/types';
import { AppState } from 'services/types';
import { makeSelectLabelDescription, makeSelectOptions } from './selectors';

export interface OwnProps {
    name: string;
    validate?: any;
    nullOnUnmount?: boolean;
    sprayMethod?: SprayMethod;
    applicationRate?: number;
    entityId?: EntityId;
    excludeEquipmentSetId?: number;
}

interface ConnectedProps {
    options?: {
        key: number;
        text: string;
        value: number;
    }[];
    labelDescription?: string;
}

type Props = OwnProps & ConnectedProps;

export class EquipmentSetDropdown extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            name,
            validate,
            options,
            nullOnUnmount = false,
            labelDescription,
            excludeEquipmentSetId
        } = this.props;

        const label = (
            <React.Fragment>
                <p className="label-title">Equipment set</p>
                <p className="label-subtitle">{labelDescription}</p>
            </React.Fragment>
        );

        let filteredOptions = options;
        if (excludeEquipmentSetId) {
            filteredOptions = options?.filter(
                (option) => option.value !== excludeEquipmentSetId
            );
        }

        return (
            <Field
                component={RenderDropdown as any}
                subscription={{
                    value: true,
                    touched: true,
                    error: true
                }}
                name={name}
                label={label}
                placeholder="Choose an equipment set"
                fluid
                search
                selection
                clearable
                selectOnBlur={false}
                validate={validate}
                options={filteredOptions}
                nullOnUnmount={nullOnUnmount}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    options: makeSelectOptions(),
    labelDescription: makeSelectLabelDescription()
});

export default connect(mapStateToProps)(EquipmentSetDropdown);
